import { checkClaimsWeb, ClaimType } from "@eventr/common";
import { useBoundStore } from "state/bound.store";

/**
 * React hook wrapper around checkClaimsWeb that subscribes to claimsVersion changes.
 *
 * Unlike raw checkClaimsWeb() which reads localStorage directly (no re-render trigger),
 * this hook subscribes to the store's claimsVersion counter. When claims are refreshed
 * (e.g. after pull-to-refresh), claimsVersion is incremented and this hook's value
 * re-evaluates, causing the consuming component to re-render.
 *
 * @param paths - The paths to check (e.g. ["/"] for global, ["/itinId"] for itinerary-specific)
 * @param claims - The claim types to check (e.g. ["userPrivateEntryViewer"])
 * @returns boolean - whether the user has the specified claims for the given paths
 */
export function useCheckClaimsWeb(paths: string[], claims: ClaimType[]): boolean {
  // Subscribe to claimsVersion to trigger re-renders when claims are refreshed.
  // We use the counter as a dependency so React re-evaluates checkClaimsWeb when it changes.
  const claimsVersion = useBoundStore((s) => s.claimsVersion);
  // Use a dummy value to force re-evaluation when claimsVersion changes
  void claimsVersion;
  return checkClaimsWeb(paths, claims);
}
